<template>
  <div>
    <!-- <div class="class-item-no" v-show="examList.length === 0">
              <img src="../../assets/images/nodata-03.png" />
              <p>暂无考试成绩</p>
            </div> -->
    <div class="score-total">
      <span
        >已过课程：<b class="color1">{{ passCourseNum }}</b> 门</span
      >
      <span
        >已修学分：<b class="color1">{{ creditNum }}</b> 分</span
      >
    </div>
    <div class="score-table">
      <div class="score-tr">
        <div class="score-th">类别</div>
        <div class="score-th">课程名称</div>
        <div class="score-th">学分</div>
        <div class="score-th">最高通过成绩</div>
        <!-- <div class="score-th">考试日期</div> -->
        <div class="score-th">已考</div>
      </div>
      <div
        class="score-tr"
        v-show="scoreList.filter((m) => m.type === 1).length > 0"
      >
        <div class="score-col">必考</div>
        <div class="score-col">
          <div
            class="score-row"
            v-for="(item, indexA) in scoreList.filter((m) => m.type === 1)"
            :key="indexA"
          >
            <div class="score-td">{{ item.courseName }}</div>
            <div class="score-td">
              {{ item.credit > 0 ? item.credit : "--" }}
            </div>
            <div class="score-td">{{ item.score > 0 ? item.score : "--" }}</div>
            <!-- <div class="score-td">{{ item.examtime }}</div> -->
            <div class="score-td">
              <a
                v-if="item.times > 0"
                class="score-td-time"
                @click="viewScoreCourseList(item)"
                >{{ item.times }}次</a
              >
              <a v-else>--</a>
            </div>
          </div>
        </div>
      </div>
      <div
        class="score-tr"
        v-show="scoreList.filter((m) => m.type === 2).length > 0"
      >
        <div class="score-col">选考</div>
        <div class="score-col">
          <div
            class="score-row"
            v-for="(item, indexA) in scoreList.filter((m) => m.type === 2)"
            :key="indexA"
          >
            <div class="score-td">{{ item.courseName }}</div>
            <div class="score-td">
              {{ item.credit > 0 ? item.credit : "--" }}
            </div>
            <div class="score-td">{{ item.score > 0 ? item.score : "--" }}</div>
            <!-- <div class="score-td">{{ item.examtime }}</div> -->
            <div class="score-td">
              <a
                v-if="item.times > 0"
                class="score-td-time"
                @click="viewScoreCourseList(item)"
                >{{ item.times }}次</a
              >
              <a v-else>--</a>
            </div>
          </div>
        </div>
      </div>
      <div
        class="score-tr"
        v-show="scoreList.filter((m) => m.type === 3).length > 0"
      >
        <div class="score-col">加考</div>
        <div class="score-col">
          <div
            class="score-row"
            v-for="(item, indexA) in scoreList.filter((m) => m.type === 3)"
            :key="indexA"
          >
            <div class="score-td">{{ item.courseName }}</div>
            <div class="score-td">
              {{ item.credit > 0 ? item.credit : "--" }}
            </div>
            <div class="score-td">{{ item.score > 0 ? item.score : "--" }}</div>
            <!-- <div class="score-td">{{ item.examtime }}</div> -->
            <div class="score-td">
              <a
                v-if="item.times > 0"
                class="score-td-time"
                @click="viewScoreCourseList(item)"
                >{{ item.times }}次</a
              >
              <a v-else>--</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal
      v-model="scoreCourseListVisible"
      title="查看成绩"
      width="800"
      footer-hide
    >
      <Table
        :columns="scoreCourseColumns"
        size="small"
        border
        :data="scoreCourseList"
      ></Table>
    </Modal>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { user } from "../../request";
export default {
  mixins: [siteMixin],
  props: {
    gradeInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      passCourseNum: 0,
      creditNum: 0,
      scoreList: [],
      scoreCourseList: [],
      scoreCourseListVisible: false,
      scoreCourseColumns: [
        {
          title: "考期",
          key: "pmName",
        },
        {
          title: "考试日期",
          key: "examtime",
          width: 150,
        },
        {
          title: "场次",
          key: "session",
          width: 90,
        },
        {
          title: "考试时间",
          width: 120,
          align: "center",
          render: (h, params) => {
            return h("span", [params.row.startTime, "~", params.row.endTime]);
          },
        },
        {
          title: "考试成绩",
          key: "score",
          width: 90,
          align: "center",
        },
        {
          title: "状态",
          width: 90,
          align: "center",
          render: (h, params) => {
            return h("span", [params.row.ispass === 1 ? "已通过" : "未通过"]);
          },
        },
      ],
    };
  },
  mounted() {
    this.getScoreList();
  },
  methods: {
    getScoreList() {
      user
        .getExamScore(this.gradeInfo.gradeCode, this.loginUser.userId)
        .then((res) => {
          //console.log("scoreList", res);
          if (res.status === 1) {
            this.passCourseNum = res.data.passcourse;
            this.creditNum = res.data.creditsum;
            this.scoreList = res.data.resultList;
          }
        });
    },
    viewScoreCourseList(item) {
      user
        .getExamCourseScore(
          this.gradeInfo.gradeCode,
          this.loginUser.userId,
          item.courseid
        )
        .then((res) => {
          //console.log("scoreListWithCourse", res);
          if (res.status === 1) {
            this.scoreCourseList = res.data;
          }
        });
      this.scoreCourseListVisible = true;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/var";
.class-item-no {
  margin: 20px auto;
  text-align: center;
  p {
    margin-top: 10px;
    font-size: 1.6rem;
    text-indent: 1em;
  }
}
.score-total {
  padding: 10px 0 10px 0;
  margin-bottom: 20px;
  text-align: center;
  background: #f5f5f5;
  border-radius: 6px;
  span {
    margin: 0 50px;
    font-weight: bold;
    font-size: 15px;
  }
}
.score-table {
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  .score-tr {
    display: flex;
    margin-left: -1px;
    margin-top: -1px;
    .score-th {
      border-top: 1px solid #ccc;
      border-left: 1px solid #ccc;
      text-align: center;
      padding: 8px 10px;
      font-weight: bold;
      &:nth-child(1) {
        width: 60px;
      }
      &:nth-child(2) {
        width: 510px;
      }
      &:nth-child(3) {
        width: 50px;
      }
      &:nth-child(4) {
        width: 120px;
      }
      &:nth-child(5) {
        width: 80px;
      }
    }
    .score-col {
      text-align: center;
      &:nth-child(1) {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        width: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &:nth-child(2) {
        width: 760px;
      }
      .score-row {
        display: flex;
        .score-td {
          padding: 8px 10px;
          border-top: 1px solid #ccc;
          border-left: 1px solid #ccc;
          .ellipsis();
          &:nth-child(1) {
            width: 510px;
          }
          &:nth-child(2) {
            width: 50px;
          }
          &:nth-child(3) {
            width: 120px;
          }
          &:nth-child(4) {
            width: 80px;
          }
          .score-td-time {
            .inline-block();
            padding: 3px 10px;
            background-color: #0092e6;
            color: #fff;
            border-radius: 6px;
            min-width: 56px;
          }
        }
      }
    }
  }
}
</style>